import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useStaffPaymentsOnly } from 'hooks/useStaffPaymentsOnly'

type StaffPaymentsOnlyGuardProps = {
	children: React.ReactNode
}

const COLLECT_PAYMENT_PATH = '/dashboard/collect-payment'

const isAllowedPath = (pathname: string): boolean => {
	const path = pathname.endsWith('/') ? pathname : `${pathname}/`
	return path === '/dashboard/' || path.startsWith(`${COLLECT_PAYMENT_PATH}/`)
}

/**
 * Guard component that restricts staff users to payment collection only.
 */
const StaffPaymentsOnlyGuard: React.FC<StaffPaymentsOnlyGuardProps> = ({ children }) => {
	const location = useLocation()
	const { restrictStaffToPaymentsOnly } = useStaffPaymentsOnly()

	if (restrictStaffToPaymentsOnly && !isAllowedPath(location.pathname)) {
		return <Navigate to={COLLECT_PAYMENT_PATH} replace />
	}

	return <>{children}</>
}

export default StaffPaymentsOnlyGuard
